/*global _ */
import {create, destroy} from '../../../lib/instances'
import {querySelectorAsync} from '../../../lib/dom'

const CONTAINER = '#reContentPlaceholder_check_card_balance_below_card_number_entry > div'
const E = {
  SHOW_SUMMARY: {
    event: 'card.check-balance.card',
    instanceName: 'check-balance-loyalty-status',
    create: {
      component: 're-loyalty-status',
      componentOptions: {
        classes: false,
        component: {
          attributes: {}
        }
      },
      target: {
        targetSelector: '.re-card-balance .re-card-balance-footer',
        root: '.check-balance-loyalty-status',
        element: '<div class="check-balance-loyalty-status"></div>',
        method: 'prependTo',
      }
    }
  }
}

const MOUNTED = 'card.check-balance.mounted'
const CART_RULE_SHOWN = 'cart-rule.confirm.check-balance-reload-upsell.mounted'
const CART_RULE_DECLINED = 'cart-rule.confirm.check-balance-reload-upsell.declined'

export default (Bus) => {
  Bus.$on(E.SHOW_SUMMARY.event, async (card, vm) => {
    deleteOnPromotion()
    if (!_.isEmpty(card) && vm.authenticated) {
      destroy(E.SHOW_SUMMARY.instanceName)
      await create(E.SHOW_SUMMARY.create, E.SHOW_SUMMARY.instanceName)
    } else {
      destroy(E.SHOW_SUMMARY.instanceName)
    }
  })
  Bus.$on(MOUNTED, vm => {
    Bus.$on(CART_RULE_SHOWN, () => {
      vm.forceHidePurchaseLink = true
    })
    Bus.$on(CART_RULE_DECLINED, () => {
      vm.forceHidePurchaseLink = false
    })
  })
}

const deleteOnPromotion = () => {
  querySelectorAsync(CONTAINER).then((element) => {
    if (element) {
      destroy(E.SHOW_SUMMARY.instanceName)
    }
  })
}

